import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.RequestPaymentUrl.IRequest;
type Response = Api.Core.Contract.RequestPaymentUrl.IResponse;
type Headers = Api.Core.Contract.RequestPaymentUrl.IHeaders;
const url = '/api/Sales/Contract/GeneratePaymentLink';
export default async function contractRequestPaymentUrlApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url),
    headers: getDefaultHeaders(),
    body,
  });
  return serverResponse;
}
